import Button from 'modules/Core/sub-modules/ui-kit/components/Button';
import { useIsOpen } from 'modules/Core/hooks/useIsOpen';
import ActivityForm from '../ActivityForm';
import styles from "./styles.module.scss";

const EditActivityButton = ({ onSuccess, activity, text = "Edit" }) => {
    const { open, close, isOpen } = useIsOpen();
    return (
        <>
            <Button className={styles.button} onClick={open}>
                {text}
            </Button>
            <ActivityForm
                title="Edit activity"
                initialState={{ name: activity?.name, text: activity?.text }}
                onSuccess={onSuccess}
                activityId={activity?.id}
                boothId={activity?.boothId}
                isOpen={isOpen}
                close={close}
            />
        </>
    )
}

export default EditActivityButton;
